import { useTranslation } from 'react-i18next';
import { Link, Navigate, useParams } from 'react-router-dom';
import { Icon } from '../../components/Icon';
import { MoleculeFactsheet } from '../chemistry/molecule/MoleculeFactsheet';
import { PublicLayout } from './PublicLayout';
import { catalogueMoleculePath } from './publicAccess';

/**
 * ADR 0017 D10 (#904): a Molecule's public address -- the same factsheet, in the public frame, for
 * signed-out visitors and shared links. The server decides who may read it (D8). ADR 0023 (#1113):
 * at `/m/<id>`, with what search engines read (ScientificMeta).
 */
export function PublicMoleculePage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/public" replace />;
  return (
    <PublicLayout>
      <Link to="/public" className="public-back">
        <Icon name="arrowBack" />
        <span>{t('publicPages.back')}</span>
      </Link>
      <MoleculeFactsheet moleculeId={id} catalogue />
    </PublicLayout>
  );
}

/** #1113 (ADR 0023 D3): the old public address, kept for links already shared; the catalogue's is `/m/<id>`. */
export function LegacyPublicMoleculeRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? catalogueMoleculePath(id) : '/public'} replace />;
}
